import { Link } from "react-router-dom";

const stats = [
  { value: "120+", label: "每日爆料更新", tone: "accent" },
  { value: "5", label: "核心新闻分类", tone: "default" },
  { value: "4", label: "深度追踪专题", tone: "default" },
  { value: "500万+", label: "累计阅读人次", tone: "default" },
];

export default function SiteIntro() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-primary-700">
              ABOUT US
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              关于 911爆料
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              911爆料 是一个聚焦爆料新闻与深度事件分析的资讯平台。我们追踪社会热点，梳理事件真相，还原独家信息，帮助读者在纷繁的信息流中快速掌握最新动态与内幕详情。
            </p>
            <ul className="mt-5 space-y-3">
              {[
                "时效优先：突发事件第一时间跟进，持续更新进展",
                "深度还原：以时间线与证据链还原事件全貌",
                "独家线索：深入调查，提供不易获取的一手信息",
              ].map((text) => (
                <li key={text} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs text-primary-800">
                    <i className="ri-check-line" />
                  </span>
                  {text}
                </li>
              ))}
            </ul>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-600"
              >
                了解更多
              </Link>
              <Link
                to="/contact"
                className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-500"
              >
                提供爆料线索
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className={`rounded-lg border p-6 ${
                  stat.tone === "accent"
                    ? "border-accent-500/50 bg-accent-500/10"
                    : "border-background-200 bg-background-50"
                }`}
              >
                <p
                  className={`font-heading text-3xl font-black md:text-4xl ${
                    stat.tone === "accent" ? "text-accent-400" : "text-foreground-950"
                  }`}
                >
                  {stat.value}
                </p>
                <p className="mt-2 text-xs text-foreground-600 md:text-sm">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}